var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 50,
    viewBox: "0 0 36 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.4167V24.6389L22.3333 28.25",
    fill: "#42DDD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 41.25C26.9746 41.25 34.25 33.9746 34.25 25C34.25 16.0254 26.9746 8.75 18 8.75C9.02537 8.75 1.75 16.0254 1.75 25C1.75 33.9746 9.02537 41.25 18 41.25Z",
    fill: "#42DDD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.4167V24.6389L22.3333 28.25M11.5 2.25H24.5M11.5 47.75H24.5M34.25 25C34.25 33.9746 26.9746 41.25 18 41.25C9.02537 41.25 1.75 33.9746 1.75 25C1.75 16.0254 9.02537 8.75 18 8.75C26.9746 8.75 34.25 16.0254 34.25 25Z",
    stroke: "#021744",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.8d2d7a248426ac7c695585046d3a7e29.svg";
export { ForwardRef as ReactComponent };